<template>
    <div id="app">
        <div class="main-info">
            <div class="topimg" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'center 0'}"> 
                <div class="samplex" style="display: flex; ">
                    <div>
                        <img class="o-w o-h" src="http://shzjapi.romis.cn:59848/tem/1.png" alt="" />不可选 
                    </div>
                    <div>
                        <img class="o-w o-h" src="http://shzjapi.romis.cn:59848/tem/22.png" alt="" />可选 
                    </div>
                    <div>
                        <img class="o-w o-h" src="http://shzjapi.romis.cn:59848/tem/23.png" alt="" />已选
                    </div>
                </div>
            </div>
            <div class="sm">        
                <div class="sm-title"></div>
                <div class="sm-line"></div>
                <div style="display: flex; justify-content: center">
                    <div>
                        <div style="display: flex" v-for="(item1, index1) in seatList" :key="index1">
                            <!-- v-if="JSON.stringify(item1) !== '{}'" -->
                            <template>
                                <div @click="seatClk(item)" class="sm-img" v-for="item in item1" :key="item.id">
                                    <img
                                        v-if="item.status === 'N'"
                                        class="o-w o-h"
                                        src="http://shzjapi.romis.cn:59848/tem/1.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.status === 'Y' && !item.isCheck"
                                        class="o-w o-h"
                                        src="http://shzjapi.romis.cn:59848/tem/22.png"
                                        alt=""
                                    />
                                    <img
                                        v-if="item.status === 'Y' && item.isCheck"
                                        class="o-w o-h"
                                        src="http://shzjapi.romis.cn:59848/tem/23.png"
                                        alt=""
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dispselect-info">            
                <div class="seat-info">
                    {{seatno}}
                </div>            
            </div>
        </div>
        <div class="gm">   
            <div class="btn">                
                <mt-button type="primary" @click="Selectseats" size="large" >{{totaljine}}确认座位</mt-button>
            </div>
        </div>
    </div>
</template>
 
<script>
import 'mint-ui/lib/style.css'
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';
import { Toast } from 'mint-ui';

export default {
    name: 'sysIndex',
    components: {},
    data() {
        return {
            bg: require('../assets/49.png'),
            ticketid:'',
            ticketname:'',
            seatno:'',
            totaljine:'',
            idnumber:'',
            username:'',
            seatnumber:'',
            info:'',
            // 页面渲染的数据
            seatList: [],
            // 后端返回的数据
            arrList: []
        };
    },
    mounted() {           
        // 1、获取选择的票号
        this.ticketid=this.$route.params.ticketid;
        if(this.ticketid==null){
            // 跳转到错误处理页
            // this.$router.push({path:'/err'});
            // 跳转到购票页
            this.$router.push({name:'ticketlist'});
        }
        // 0、获取座位使用信息
        // console.log('ticketid',this.ticketid);
        var apix='http://shzjapi.romis.cn:59848/api/refreshseatlist?ticketid=' + this.ticketid;
        Axios.get(apix).then((response)=>{            
            if(response.data.result=='false'){
                //alert('false');
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                // console.log('seatnumber',this.seatnumber);
            }
            else{
                // 解码用 
                this.arrList=response.data.data     
                this.seatnumber=response.data.seatnumber;
                // console.log('seatnumber',this.seatnumber);
            }
        }).catch((err)=>{
            alert('获取座位占用信息失败：' + err);
        })
        // alert(this.ticketid);
        // 获取座位列表
        this.getTicketInfo();
        var api='http://shzjapi.romis.cn:59848/api/getseatlist';
            Axios.get(api).then((response)=>{            
                if(response.data.result=='false'){
                    //alert('false');
                    // 无记录
                    // this.$router.push({path:'/err'});
                    this.info=response.data.errmsg;
                }
                else{
                    // 解码用 
                    // console.log(response);
                    this.arrList=response.data.data     
                    //alert("before:" + this.arrList.length);   
                    //alert("mounted:" + this.arrList.length);
                    // 找到行的最大值
                    const rowMax = this.findObjInArrMax(this.arrList, 'rowNo', true);
                    // 找到列的最大值
                    const colMax = this.findObjInArrMax(this.arrList, 'colNo', true);

                    const rowNoMax = parseInt(rowMax.rowNo) + 1;
                    const colNoMax = parseInt(colMax.colNo) + 1;
                    // 将一维数组装成二维数组
                    let list = [];
                    for (var index = 0; index < rowNoMax; index++) {
                        list[index] = [];
                        for (var index1 = 0; index1 < colNoMax; index1++) {
                            list[index][index1] = {};
                        }
                    }
                    // 后端返回的数据组合到二维数组里面
                    list.forEach((item1, index1) => {
                        item1.forEach((item2, index2) => {
                            this.arrList.forEach((item, index) => {
                                item.isCheck = false;
                                if(this.seatnumber.indexOf('|' + item.seatNo + '|')>0){
                                    item.status='N';
                                }                                
                                list[item.rowNo][item.colNo] = item;
                            });
                        });
                    });
                    //console.log('list', list);
                    this.seatList = list;

                }
            }).catch((err)=>{
                alert('seatlist获取座位列表失败：' + err);
            })
        
    },
    methods: {
        // 加载座位列表
        getSeatList(){
            var api='http://shzjapi.romis.cn:59848/api/getseatlist';
            Axios.get(api).then((response)=>{            
                if(response.data.result=='false'){
                    //alert('false');
                    // 无记录
                    // this.$router.push({path:'/err'});
                    this.info=response.data.errmsg;
                }
                else{
                    // 解码用 
                    // console.log(response);
                    this.arrList=response.data.data                
                }
            }).catch((err)=>{
                alert('seatlist获取座位列表失败：' + err);
            })
        },
        // 点击座位表
        seatClk(item) {
            // 如果是可以选择，而且没有选中状态
            if (item.status === 'Y' && !item.isCheck) {
                item.isCheck = true;  
                // console.log(item.seatNo);     
                // console.log(this.ticketid);
                this.seatno=item.seatNo;
                this.seatList.forEach(function(item1, index1){
                    item1.forEach(function(item2, index2){                      
                        if(item2.seatNo!=item.seatNo)
                        {
                            item2.isCheck=false;
                        }
                    });
                });

            } else if (item.status === 'Y' && item.isCheck) {
                item.isCheck = false;
            }
            //console.log(item);
            this.$forceUpdate();
        },
        // 确认选座
        Selectseats(){
            // console.log('ticket',this.ticketid); 
            //     console.log('seatno',this.seatno); 
            // 1、验证是否有个人信息，没有则跳转到填写个人信息页
            var temidnumber = localStorage.getItem('idnumber');
            var temname = localStorage.getItem('username');
            if(temidnumber!='undefined' && temidnumber!=null && temname!='undefined' && temname!=null){
                // 缓存存在
                this.idnumber=temidnumber
                this.username=temname;
                // 2、直接提交
                
            }
            else
            {
                // console.log('ticket',this.ticketid); 
                // console.log('seatno',this.seatno); 
                // 跳转到个人信息页
                this.$router.push({name:'personinfo',params:{'ticketid':this.ticketid,'ticketname':this.ticketname,'seatno':this.seatno}});
            }
        },
        // 保存个人信息
        saveInfoNew(){
        //alert('保存基本信息');
        // 1、验证数据有效性
        if(!this.CheckData())
        {
            return;
        }
        // 2、保存数据到缓存
        localStorage.setItem('idnumber',this.idnumber);    
        localStorage.setItem('username',this.username);  
        // 3、判断如果有票信息、座位信息，则直接提交购票，无则提示保存成功
        if(this.ticketid!=null && this.seatno!=null)
        {
            this.billid = "WX0028" + this.formatDatetimeString()
                        + this.generateRandomNumber()
                        + "1"
                        + "0";
            this.ordertime=this.formattedTime();
            this.starttime=this.formattedTime();
            this.endtime=this.formattedTime();

            console.log('billid',this.billid);
            console.log('ordertime',this.ordertime);
            console.log('datetimestring',this.formatDatetimeString());
            // 直接提交购票
            var api='http://shzjapi.romis.cn:59848/api/savesalse';
            Axios.post(api,qs.stringify({
                'ticketid':this.ticketid,
                'bustype':1,
                'price':0,
                'number':1,
                'total':0,
                'billid':this.billid,
                'paytype':1,
                'ordertime':this.ordertime,
                'cardno':this.idnumber,
                'num':1,
                'starttime':this.starttime,
                'endtime':this.endtime,
                'operator':'ON-LINE',
                'mem':this.ticketname,
                'officename':'1号厅',
                'seatnumber':this.seatno,
                'name':this.personname
                }),{emulateJSON: true},{
                headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
                }).then(response=>{
                // console.log(response);
                if(response.data.result=='false'){
                // 购票失败
                this.resulttip=response.data.errmsg;
                this.show();
                return;
                }
                this.resulttip="出票成功";
                this.show();
                // 跳转到预约首页
                this.$router.push({path:'/ticketlist'});
            }),function(err){
                // 保存出错
                this.resulttip="保存信息成功";
                show();
            }
        }
        else
        {
            this.resulttip="请按正常流程购票";
            show();
        }
        },
        //获取票信息
        getTicketInfo(){
            var api='http://shzjapi.romis.cn:59848/api/getticketinfo?ticketid=' + this.ticketid;
            Axios.get(api).then((response)=>{            
                if(response.data.result=='false'){
                    // 无记录
                    // this.$router.push({path:'/err'});
                    this.info=response.data.errmsg;
                }
                else{
                    // 解码用 
                    // console.log('getTicketInfo ticketname',response.data.data.name);
                    this.ticketname=response.data.data.name;                       
                }
            }).catch((err)=>{
                alert('获取座位信息失败：' + err);
            })
        },
        // 找到数组对象中的最大值
        findObjInArrMax(list, atr, returnVal) {
            let res = Math.max.apply(
                Math,
                list.map((item) => {
                    return item[atr];
                })
            );
            if (returnVal) {
                return list.filter((item) => {
                    return item[atr] == res;
                })[0];
            } else {
                return res;
            }
        },
        // 找到数组对象中的最小值
        findObjInArrMin(list, atr, returnVal) {
            let res = Math.min.apply(
                Math,
                list.map((item) => {
                    return item[atr];
                })
            );
            if (returnVal) {
                return list.filter((item) => {
                    return item[atr] == res;
                })[0];
            } else {
                return res;
            }
        }
    }
};
</script>
 
<style>
#app,/*设置占满*/
html,
body {
  /* background-color: #190af0; */
  width: 100%;
  height: 50%;
  /* margin-top:-60px; */

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
.topimg{
    width: 100%;
    height: 180px;
    margin: 0px;
    /* background-color: red; */
}
.samplex{
    margin-top: 80px;
    margin-left: 80px;
}
.sm-img {
    width: 10px;
    height: 10px;
    margin: 2px;
    object-fit:cover;    
}
.sm-img  img{
    width: 10px;
    height: 10px;
    margin-right: 2px;
    margin-top: 3px;
    margin-bottom: 3px;
    object-fit:cover;    
}
.sm {
    position: relative;
    /* background-color: red; */
}
.sm-line {
    width: 0;
    height: 100vh;
    border: 1px dashed #ccc;
    position: absolute;
    top: 18px;
    left: 50%;
}
.sm-title {
    background-color: #dddddd;
    width: 190px;
    height: 17px;
    -webkit-transform: perspective(17px) rotateX(-10deg);
    transform: perspective(17px) rotateX(-10deg);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
}

.gm{
    width: 100%;
    height: 64px;
    /* background-color: blueviolet; */
    /* display: -moz-box;
    display: -webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical; */
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dispselect-info{
    width: 100%; /* 矩形宽度 */
    height: 60px; /* 矩形高度 */
    /* background-color: #42b983;  */
}
.seat-info{
    width: 100%; /* 矩形宽度 */
    height: 60px; /* 矩形高度 */
    /* background-color: #42b983;  */
    border-radius: 15px; /* 圆角半径 */
    color: rgb(0, 0, 0); /* 文字颜色 */
    display: flex;
    justify-content: center;
    align-items: left;
    text-align: center;
}
.btn{
    width: 90%;
    height: 52px;
    /* background-color: green; */
}
</style>


// WEBPACK FOOTER //
// src/components/Selectseat.vue